"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProvider = exports.useUserContext = exports.UserContext = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const useGetCurrentUser_1 = require("./hooks/useGetCurrentUser");
const useGetPermissions_1 = require("./hooks/useGetPermissions");
const StyledSpinnerContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`;
exports.UserContext = react_1.default.createContext({
    user: undefined,
    setUser: () => { },
    refreshUser: () => { }
});
const useUserContext = () => {
    const context = (0, react_1.useContext)(exports.UserContext);
    if (!context) {
        throw new Error('useUserContext must be used within the UserProvider component');
    }
    return context;
};
exports.useUserContext = useUserContext;
function UserProvider(props) {
    const { children } = props;
    const [userContext, setUser] = (0, react_1.useState)(undefined);
    const { currentUser, getCurrentUser } = (0, useGetCurrentUser_1.useGetCurrentUser)();
    const { permissions, getPermissions } = (0, useGetPermissions_1.useGetPermissions)();
    const accessToken = core_ui_1.api.getAccessToken();
    // console.log('currentUser', currentUser);
    (0, react_1.useEffect)(() => {
        if (accessToken) {
            getCurrentUser();
        }
        else {
            setUser(null);
        }
    }, [accessToken, getCurrentUser]);
    // only set user if null/undefined so that userContext will rely on
    // user being set on userContext from consumer side (e.g. QMS web)
    (0, react_1.useEffect)(() => {
        setUser(user => user || currentUser);
    }, [currentUser]);
    (0, react_1.useEffect)(() => {
        getPermissions();
    }, [getPermissions]);
    if (userContext === undefined) {
        // Do not load the children of the provider if the user is undefined.
        // Lets further wait...
        // undefined = we have not determined the login state yet
        // null = not logged in
        // User value = logged in
        return (react_1.default.createElement(StyledSpinnerContainer, null,
            react_1.default.createElement(core_1.CircularProgress, { size: 64 })));
    }
    return (react_1.default.createElement(exports.UserContext.Provider, { value: {
            user: userContext,
            permissions,
            setUser,
            refreshUser: getCurrentUser
        } }, children));
}
exports.UserProvider = UserProvider;
//# sourceMappingURL=UserContext.js.map